module.exports = __webpack_public_path__ + "img/empty.bcc6408f.png";